export const MIN_LATTITUDE = -90;
export const MAX_LATTITUDE = 90;
export const MAX_LONGITUDE = 180;
export const MIN_LONGITUDE = -180;
export const PLUGIN_PREFIX = 'fe-grid';
export const classnames = {
    container: 'geogrid',
    containerOverride: 'geogrid-overrides',
    label: 'geogrid__label'
};
